module.exports = __webpack_public_path__ + "assets/img/binding-3-sm.3f3f2205.jpg";